import { configureStore } from "@reduxjs/toolkit";
import { rootReducer as reducer } from "tanyacare-middleware";

export const store = configureStore({
  reducer,
});
